import React, { createContext, useContext, useMemo } from "react";
import useUploadDocuments from "ApiLayer/Documents/mutationUploadDocuments";

interface UploadRequest {
    file: File;
    buildingModelUid: string;
    description?: string;
}

interface UploadContextValue {
    startUpload: (request: UploadRequest) => void;
}

const UploadContext = createContext<UploadContextValue | null>(null);

export function UploadProvider({ children }: { children: React.ReactNode }) {
    const uploadMutation = useUploadDocuments();

    // UseMemo brings benefits to context providers, otherwise each component using it will rerender
    const contextValue = useMemo(
        () => ({
            startUpload: (request: UploadRequest) => uploadMutation.mutate(request),
        }),
        [uploadMutation]
    );

    return <UploadContext.Provider value={contextValue}>{children}</UploadContext.Provider>;
}

export function useUpload() {
    const context = useContext(UploadContext);
    if (!context) {
        throw new Error("useUpload must be used within an UploadProvider");
    }
    return context;
}
